module.exports = __webpack_public_path__ + "assets/img/user.6c8f0925.svg";